import { useLanguage } from "../../../../../stores/LanguageStore";
import { useDisclosure } from "@mantine/hooks";
import { Button, Modal } from "@mantine/core";
import { IconStar } from "@tabler/icons-react";
import ScoreContent from "./ScoreContent";

const ScoreSettings = ({ disabled }) => {
  const lang = useLanguage((s) => s.language);
  const [opened, { open, close }] = useDisclosure();

  return (
    <>
      <Button
        variant="light"
        radius={"md"}
        leftSection={<IconStar size={20} />}
        w={"100%"}
        justify="start"
        onClick={open}
        disabled={disabled}
      >
        {lang.leads.scoring_settings}
      </Button>

      <Modal
        opened={opened}
        onClose={close}
        title={lang.prm.scoring.dialog_title}
        size={"50%"}
      >
        <ScoreContent handleClose={close} />
      </Modal>
    </>
  );
};

export default ScoreSettings;
